<!--  Use our app Section -->
@if(!hideAppSection()){
<section class="container-fluid useourapp-section">
  <div class="container">
    <app-imagebox-one [showAppBtns]="true" [isImageLeft]="false" [imageStyle]="'max-height:518px;'"
      [heading]="('FOOTER.APPINFOTITLE' | translate)" [image]="sharedService.imagesUrl+'Footer-Mobile-bg.png'"
      [image]="sharedService.imagesUrl+'responcv-mobile-img.png'"></app-imagebox-one>
  </div>
</section>
}

<!--  Use our app Section End -->
@if(!hideFooterMainSection()){
<footer class="container-fluid">
  <div class="container">

    <div class="row quotetion-row" *ngIf="sharedService.hideFooterRightSection">
      <div class="col-lg-3 col-md-4 col-sm-3 iconfooter-quotetion">
        <div class="footer-desc-section-icons-quotation">
          <div class="footer-desc-section-icon-quotation" *ngIf="!!FacebookLink">
            <a [href]="FacebookLink" target="_blank" class="img-tage">
              <img src="{{sharedService.imagesUrl}}icons/facebook-white.svg" class="img-fluid facbook-quation" />
            </a>

          </div>
          <div class="footer-desc-section-icon-quotation" *ngIf="!!LinkedinLink">
            <a [href]="LinkedinLink" target="_blank" class="img-tage">
              <img src="{{sharedService.imagesUrl}}icons/linkedin-white.svg" class="img-fluid linkedin-quation" />
            </a>
          </div>
          <div class="footer-desc-section-icon-quotation" *ngIf="!!InstragramLink">
            <a [href]="InstragramLink" target="_blank" class="img-tage">
              <img src="{{sharedService.imagesUrl}}icons/instagram-white.svg" class="img-fluid" />
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-9 col-md-8 col-sm-9 term-content">
        <div class="copyrightdiv-logo quotetation-logos">
          <!-- Image will moved to assets later -->
          <img *ngIf="showPciComplaint" [src]="sharedService.imagesUrl+'pci-complaint.svg'" width="46" height="56" alt="" />
          <img *ngIf="showAicpaIcon" [src]="sharedService.imagesUrl+'aicpa-icon.svg'" width="47" height="56" alt="" />
          <img *ngIf="showHippaCompliance" [src]="sharedService.imagesUrl+'hippa-compliance.svg'" width="77" height="56" alt="" />

          <!-- Image will moved to assets later -->
        </div>
        <div class="quotetion-copyright">
          <div class="copyrightdiv-text">
            Copyright © {{currentYear}} WoW Health Solutions. All Rights Reserved
          </div>
          <!-- <div class="termprivacy"> -->
          <a (click)="openTermUseModal()">Terms of use</a>
          <!-- <a (click)="openPrivacyPoliciesModal()">Privacy policy</a> -->
          <!-- </div> -->
        </div>
      </div>
      <div class="col-lg-12 qutetion-col">
        <div class="responcive-write">
          <a (click)="openTermUseModal()">Terms of use</a>
          <div class="copyrightdiv-text quotation-copy">
            Copyright © {{currentYear}} WoW Health Solutions. All Rights Reserved
          </div>
          <!-- <div class="termprivacy"> -->
          <!-- <a (click)="openPrivacyPoliciesModal()">Privacy policy</a> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    @if(!sharedService.hideFooterRightSection && !hasWellnessMembership){
    <div class="row">
      <div class="col-md-12 ">
        <div class="footer-disclaimer">
          <h4 class="mb-3 mt-0"> {{ 'FOOTER.DISCLAIMER_TITLE' | translate: { tenant: 'WOW' } }}</h4>
          <p class="m-0">
            {{ 'FOOTER.DISCLAIMER_DESCRIPTION' | translate: { tenant: 'WOW' } }}
          </p>
        </div>
      </div>
    </div>
    }
    <div class="row copyright-section" *ngIf="!sharedService.hideFooterRightSection">
      <div class="col-md-12 d-flex justify-content-between align-items-end flex-wrap">
        <div class="copyrightdiv-logo order-1 order-md-3 w-xs-100 ">
          <!-- Image will moved to assets later -->
          <img *ngIf="showPciComplaint" [src]="sharedService.imagesUrl+'pci-complaint.svg'" width="64" height="56" alt="" />
          <img *ngIf="showAicpaIcon" [src]="sharedService.imagesUrl+'aicpa-icon.svg'" width="62" height="56" alt="" />
          <img *ngIf="showHippaCompliance" [src]="sharedService.imagesUrl+'hippa-compliance.svg'" width="104" height="56" alt="" />

          <!-- Image will moved to assets later -->
        </div>
        <!-- <div class="copyrightdiv-left"> -->
        <div class="copyrightdiv-text order-3 order-md-2 w-xs-100">
          Copyright © {{currentYear}} WoW Health Solutions. All Rights Reserved
        </div>
        <div class="termprivacy order-2 order-md-1 w-xs-100">
          <div class="footer-icons-container">
              <div class="footer-desc-section-icons-quotation">
              <div class="footer-desc-section-icon-quotation" *ngIf="!!FacebookLink">
                <a [href]="FacebookLink" target="_blank" class="img-tage">
                  <!-- <img src="{{sharedService.imagesUrl}}icons/facebook-white.svg" class="img-fluid facbook-quation" /> -->
                  <div [innerHTML]="facebookSvg" class="img-fluid facbook-quation icon-color"></div>
                </a>
              </div>
              <div class="footer-desc-section-icon-quotation" *ngIf="!!LinkedinLink">
                <a [href]="LinkedinLink" target="_blank" class="img-tage">
                  <!-- <img src="{{sharedService.imagesUrl}}icons/linkedin-white.svg" class="img-fluid linkedin-quation" /> -->
                  <div [innerHTML]="linkedInSvg" class="img-fluid linkedin-quation icon-color"></div>
                </a>
              </div>
              <!-- <div class="footer-desc-section-icon-quotation" *ngIf="!!TwitterLink">
                <a [href]="TwitterLink" target="_blank" class="img-tage"> -->
                  <!-- <img src="{{sharedService.imagesUrl}}icons/twitter-white.svg" class="img-fluid twitter-quation" /> -->
                  <!-- <div [innerHTML]="twitterSvg" class="img-fluid twitter-quation icon-color"></div>
                </a>
              </div> -->
            </div>
            <div class="copyrightdiv-logo-mobile order-1 order-md-3 w-xs-100 ">
              <!-- Image will moved to assets later -->
              <img *ngIf="showPciComplaint" [src]="sharedService.imagesUrl+'pci-complaint.svg'" width="37" height="32" alt="" />
              <img *ngIf="showAicpaIcon" [src]="sharedService.imagesUrl+'aicpa-icon.svg'" width="37" height="32" alt="" />
              <img *ngIf="showHippaCompliance" class="hippaIcon" [src]="sharedService.imagesUrl+'hippa-compliance.svg'" width="37" height="32" alt="" />

              <!-- Image will moved to assets later -->
            </div>
          </div>
          <a class="terms-text" (click)="openTermUseModal()">Terms of use</a>
          <!-- <a (click)="openPrivacyPoliciesModal()">Privacy policy</a> -->
        </div>
        <!-- </div> -->
      </div>
    </div>

  </div>
</footer>
}
<app-terms-of-use-modal></app-terms-of-use-modal>

<!-- <app-privacy-policy-modal></app-privacy-policy-modal> -->